<template>
  <div :class="cardClasses" @click="onClickCard">
    <div class="card__top" v-if="hasTopSlot">
      <m4-alert :variant="topAlertVariant">
        <slot name="top"></slot>
      </m4-alert>
    </div>
    <div :class="'card__icon card__icon--' + iconVariant" v-if="icon">
      <m4-icon :icon="icon"></m4-icon>
    </div>
    <div class="card__image" v-if="imgSrc">
      <img :src="imgSrc" :alt="title" />
    </div>
    <div class="card__text-wrapper">
      <div class="card__header" v-if="title || subtitle">
        <h2 class="card__header__title">
          {{ title }}
          <small class="card__header__title__subtitle" v-if="subtitle">
            {{ subtitle }}
          </small>
        </h2>
      </div>
      <div class="card__body" v-if="hasBodySlot">
        <slot></slot>
      </div>
    </div>
    <div class="card__footer" v-if="hasFooterSlot">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4Card",
  props: {
    imgSrc: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    onClickBtn: {
      type: Function,
      required: false
    },
    horizontal: {
      type: Boolean,
      required: false
    },
    topAlertVariant: {
      type: String,
      default() {
        return "warning";
      }
    },
    borderVariant: {
      type: String
    },
    bgVariant: {
      type: String
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    link: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    iconVariant: {
      type: String,
      default() {
        return "primary";
      }
    },
    iconVariantBigger: {
      type: Boolean,
      default() {
        return false;
      }
    },
    flat: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  emits: ["onClickBtn"],
  computed: {
    hasTopSlot() {
      return typeof this.$slots.top === "function";
    },
    hasBodySlot() {
      return typeof this.$slots.default === "function";
    },
    hasFooterSlot() {
      return typeof this.$slots.footer === "function";
    },
    cardClasses() {
      let classes = ["card"];
      if (this.horizontal) {
        classes.push("card--horizontal");
      }
      if (this.hasFooterSlot) {
        classes.push("card--has-footer");
      }
      if (this.hasTopSlot) {
        classes.push("card--has-top");
        classes.push("card--border-" + this.topAlertVariant);
      } else if (this.borderVariant) {
        classes.push("card--border-" + this.borderVariant);
      }
      if (this.bgVariant) {
        classes.push("card--bg-" + this.bgVariant);
      }
      if (this.disabled) {
        classes.push("card--disabled");
      }
      if (this.flat) {
        classes.push("card--flat");
      }
      if (this.link) {
        classes.push("card--link");
      }
      if (this.icon) {
        classes.push("card--with-icon");
      }
      if (this.iconVariantBigger) {
        classes.push("card--bigger-icon");
      }
      return classes.join(" ");
    }
  },
  methods: {
    pushButton() {
      this.$emit("onClickBtn");
    },
    onClickCard() {
      if (this.link) {
        location.href = this.link;
      }
      return true;
    }
  }
};
</script>
